// stores 
import * as ProtocolConsumptionStore from '../../../redux/middleware/ProtocolConsumptionMiddleware';
import * as ProtocolStore from '../../../redux/middleware/MedicalProtocolMiddleware';
import * as SettlementStore from '../../../redux/middleware/SettlementMiddleware';

// state
import { AppState } from '../../../redux/reducers';

// models
import { ProtocolConsumption } from '../../../models/Entities/Protocols/ProtocolConsumption';
import { Protocol } from '../../../models/Entities/Protocols/Protocol';
import { Settlement } from '../../../models/Entities/Settlements/Settlement';

//#region Props

interface IProps {
    ProtocolId: number;
    ProtocolConsumptionId: string;
}

interface ConnectedProps {
    // loading
    isLoading: boolean;
    successLoading: boolean | undefined;
    failLoading: boolean;
    errorLoading: TypeError | null;

    Consumption: ProtocolConsumption | null;
    ContractId: number | undefined;
    Settlement: Settlement | null;
}

interface MedicalServicesDispatchProps {
    GetProtocolConsumptionById: typeof ProtocolConsumptionStore.ActionCreators.GetProtocolConsumptionById;
    GetAllProtocolContractAssociations: typeof ProtocolStore.actionCreators.GetAllProtocolContractAssociations;
    GetSettlementById: typeof SettlementStore.actionCreators.GetSettlementById;
}

export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
    
    const AuxProtocol: Protocol| null =  state.MedicalProtocols?.list?.find((protocol: Protocol) => protocol.id === ownProps.ProtocolId) || null;

    const AuxConsumption: ProtocolConsumption | null =
        AuxProtocol?.consumptions?.find((consumption: ProtocolConsumption) => consumption.id === ownProps.ProtocolConsumptionId) ??
        AuxProtocol?.consumptions?.flatMap((consumption: ProtocolConsumption) => consumption.childConsumption ?? [])
            .find((consumption: ProtocolConsumption) => consumption.id === ownProps.ProtocolConsumptionId) ??
        null;

    const AuxContractId: number | undefined = AuxProtocol?.contractAssociation?.contractId ?? undefined;

    const AuxSettlement: Settlement | null = state.Settlement?.list?.find((settlement: Settlement) => settlement.id === AuxConsumption?.settlementId) || null;

    return {
        // loading
        isLoading: state.MedicalProtocols?.isLoadingOneConsumption || state.Settlement?.isLoadingOne || false,
        successLoading: (state.MedicalProtocols?.LoadingOneConsumptionSuccess && state.Settlement?.successLoadingOne) || undefined,
        failLoading: state.MedicalProtocols?.FailGettingOneConsumption || state.Settlement?.failOnLoadingOne || false,
        errorLoading: state.MedicalProtocols?.ErrorGettingOneConsumption || state.Settlement?.error || null,
    
        Consumption: AuxConsumption,
        ContractId: AuxContractId,
        Settlement: AuxSettlement
    }
};

export const mapDispatchToProps = {
    ...ProtocolConsumptionStore.ActionCreators,
    ...ProtocolStore.actionCreators,
    ...SettlementStore.actionCreators,
};